import UiHelper from './UiHelper';
import { Form } from './Form';
import commentTemplate from '../../../templates/comment.tpl';


class CommentForm
{
    static init()
    {
        this.form = UiHelper.getNode('.js-comment-form')
        if (!this.form) return;

        this.addCommentLink = UiHelper.getNode('.js-add-comment');
        this.replyToInput = UiHelper.getNode('.js-comment-form__reply-to-input');
        this.replyToUser = UiHelper.getNode('.js-comment-form__reply-to-user');
        this.cancelReply = UiHelper.getNode('.js-comment-form__reply-to-cancel');
        this.feedbackMsg = UiHelper.getNode('.js-comment-form__feedback-msg');

        this.handleResponse = this.handleResponse.bind(this);
        this.doReply = this.doReply.bind(this);

        new Form(this.form, {
            loadingClass: 'comment-form--loading',
            handleResponse: this.handleResponse
        });

        this.initCommentReplies();

        this.addCommentLink.addEventListener('click', e => { UiHelper.scrollTo(this.form); })
    }

    static handleResponse(response)
    {
        this.form.classList.remove('comment-form--loading');

        if (response.success)
        {
            //this.feedbackMsg.classList.add('comment-form__feedback-msg--success');
            this.form.reset();
            this.form.classList.remove('comment-form--replying');
        }
        else
        {
            this.feedbackMsg.classList.add('comment-form__feedback-msg--error');
        }

        this.feedbackMsg.innerHTML = `<p>${response.message}</p><button class="btn theme-bgclr-1" type="button">${window.labels.close}</button>`;

        this.form.classList.add('comment-form--feedback');

        this.feedbackMsg.querySelector('.btn').addEventListener('click', e =>
        {
            this.feedbackMsg.classList.remove('comment-form__feedback-msg--success');
            this.feedbackMsg.classList.remove('comment-form__feedback-msg--error');
            this.form.classList.remove('comment-form--feedback');

            if (response.success && response.publish && response.comment)
            {
                this.addComment(response.comment)
            }
        });
    }

    static addComment(comment)
    {
        let classes = [];
        if (comment.replyTo > 0) classes.push('depth-2');
        if (comment.byPostAuthor > 0) classes.push('bypostauthor');

        const commentMarkup = commentTemplate({
            id: comment.id,
            author: comment.author,
            message: comment.message,
            timestamp: comment.timestamp,
            replyTo: comment.replyTo,
            replyToLabel: window.labels.replyToComment,
            classes
        });

        const addTo = comment.replyTo === '0' ? UiHelper.getNode('.js-comments') : UiHelper.getNode(`#comment-${comment.replyTo} .children`);
        addTo.insertAdjacentHTML('beforeend', commentMarkup);

        UiHelper.getNode(`#comment-${comment.id} .comment-reply-link`).addEventListener('click', this.doReply);

        UiHelper.scrollTo(`#comment-${comment.id}`);
    }

    static initCommentReplies()
    {
        Array.from(UiHelper.getNodes('.comment-reply-link')).forEach(replyLink =>
        {
            replyLink.onclick = null; // disable wordpress onclick
            replyLink.addEventListener('click', this.doReply);
        });

        this.cancelReply.addEventListener('click', e =>
        {
            e.preventDefault();
            this.replyToInput.value = 0;
            this.form.classList.remove('comment-form--replying');
        });
    }

        static doReply(e)
        {
            e.preventDefault();

            const commentId = e.currentTarget.parentNode.parentNode.id.split('-').pop();
            const commentAuthor = document.querySelector(`#comment-${commentId} .comment-author cite`).textContent;

            this.replyToInput.value = commentId;
            this.replyToUser.textContent = commentAuthor;

            this.form.classList.add('comment-form--replying');

            UiHelper.scrollTo(this.form);
        }

}

export default CommentForm;
